export default __webpack_public_path__ + "static/media/Eye_7_F_C6.00ccaba1.svg";